/** Қазақша — навигация, подвал, cookie, 404 */
export const layoutKk: Record<string, string> = {
  "nav.logoAria": "IT-24.pro басты бетке",
  "nav.devops": "Қызметтер",
  "nav.admin": "Аудит",
  "nav.support": "Шұғыл көмек",
  "nav.vps": "Байланыс",
  "nav.k8s": "Жобалар",
  "nav.cicd": "Кейстер",
  "nav.ddos": "Мен туралы",
  "nav.llmops": "Retainer",
  "nav.packages": "Қызметтер",
  "nav.audience": "Кімге",
  "nav.cases": "Кейстер",
  "nav.portfolio": "Кейстер",
  "nav.contacts": "Байланыс",
  "nav.auditCta": "Telegramға жазу",
  "nav.auditCtaShort": "Telegram",
  "nav.ariaMain": "Негізгі навигация",
  "nav.langSwitcherAria": "Сайт тілі",
  "nav.menuOpen": "Навигация мәзірін ашу",
  "nav.menuClose": "Мәзірді жабу",
  "nav.langRu": "RU",
  "nav.langUk": "UA",
  "nav.langKk": "KZ",
  "nav.langUz": "UZ",
  "nav.langKy": "KG",

  "footer.tagline":
    "Төлем, айырбас және highload инфрақұрылымы. Польша заңды тұлғасы · Telegram.",
  "footer.badge1": "✓ PCI / DDoS / K8s",
  "footer.badge2": "✓ USDT / инвойс",
  "footer.badge3": "✓ 2010 жылдан инфрақұрылымда",
  "footer.consultCta": "Telegramға жазу",
  "footer.servicesTitle": "Қызметтер",
  "footer.tariffsHome": "Басты беттегі қызметтер",
  "footer.devops": "DevOps retainer",
  "footer.serverSupport": "Шұғыл көмек",
  "footer.serverAdmin": "Аудит",
  "footer.k8s": "PCI / DDoS / K8s жобалары",
  "footer.cicd": "Кейстер",
  "footer.ddos": "Мен туралы",
  "footer.llmops": "Байланыс",
  "footer.vps": "nexops.eu (EU)",
  "footer.vacancies": "Telegram",
  "footer.contactTitle": "Байланыс",
  "footer.location": "Konin, Poland",
  "footer.copy": "Барлық құқықтар қорғалған.",
  "footer.taglineBottom": "Төлем · финтех · highload · Telegram",

  "cookie.title": "Сайтты ыңғайлы ету үшін cookie қолданамыз",
  "cookie.body":
    "Cookie файлдары навигация мен кейбір функциялар үшін керек. Сайтты пайдалана берсеңіз, осыған келісесіз.",
  "cookie.reject": "Бас тарту",
  "cookie.accept": "Қабылдау",

  "notFound.title": "Бет табылмады | IT-24.pro",
  "notFound.description":
    "Мұндай бет жоқ. Төлем мен финтех инфрақұрылымы — басты бетте.",
  "notFound.h1": "Бет табылмады",
  "notFound.text":
    "Сілтеме ескі болуы мүмкін — бұрынғы қызметтер жаңа бөлімдерге көшті.",
  "notFound.home": "Басты бетке",
  "notFound.devops": "Retainer / қызметтер",

  "breadcrumb.home": "Басты бет",
  "breadcrumb.devopsServices": "Қызметтер",
  "breadcrumb.ariaLabel": "Навигация жолы",

  "search.title": "Сайттан іздеу | IT-24.pro",
  "search.titleWithQuery": "Іздеу: {query} | IT-24.pro",
  "search.description": "IT-24.pro қызметтерін іздеу: retainer, аудит, PCI, DDoS, Kubernetes.",
  "search.h1": "Сайттан іздеу",
  "search.lead": "Қызметті табыңыз: шұғыл көмек, аудит, retainer, жобалар.",
  "search.placeholder": "Мысалы: pci, ddos, retainer",
  "search.submit": "Іздеу",
  "search.prompt": "Сұрау жазыңыз — сәйкес бөлімдерді көрсетеміз.",
  "search.resultsCount": "Табылды: {count}",
  "search.noResults": "«{query}» бойынша ештеңе табылмады.",
  "search.emptyHint": "Басқа кілт сөздерді көріңіз немесе қызметтерге өтіңіз.",
};
